"use strict";
angular.module("internal.exams").controller("InternalExamViewsPreview", ["$scope",
    "$stateParams",
    "EXSessions",
    function ($scope, $stateParams, EXSessions) {
        $scope.preview = $stateParams.queryId;
        EXSessions.get().then(function (Sessions) {
            $scope.Sessions = Sessions.records;
            $scope.Sessions.forEach(function (session) {
                session.coordinatorUsersList = '';
                session.examinerUsersList = '';
                session.coordinatorUsers.forEach(function (coordinatorUser) {
                    session.coordinatorUsersList += coordinatorUser.id + ',';
                });
                session.examinerUsers.forEach(function (examinerUser) {
                    session.examinerUsersList += examinerUser.id + ',';
                });
            });
            $scope.loading = false;
        });
    }]);